module.exports = __webpack_public_path__ + "img/copy_grey.7dd99a2a.svg";